var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';
import { HasSubscriptions } from '../has-subscriptions';
import { StyleService } from '../../services/style/style.service';
import { ActivatedRoute } from '@angular/router';
var DrawerComponent = /** @class */ (function (_super) {
    __extends(DrawerComponent, _super);
    function DrawerComponent(_renderer, activatedRoute, // do not remove this - without it all changes on local-dev require a complete rebuild for some reason
    styleService, changeDetectorRef) {
        var _this = _super.call(this) || this;
        _this._renderer = _renderer;
        _this.activatedRoute = activatedRoute;
        _this.styleService = styleService;
        _this.changeDetectorRef = changeDetectorRef;
        _this.drawerOpen = false;
        return _this;
    }
    // dynamically inject template
    DrawerComponent.prototype.openDrawer = function (drawerTemplate) {
        this.drawerOpen = true;
        this.changeDetectorRef.detectChanges(); // ensure ngif is rendered first
        this.drawerContentRef.clear();
        this.drawerContentRef.createEmbeddedView(drawerTemplate);
        this.styleService.addClass(this._renderer, 'html', 'no-scroll');
    };
    DrawerComponent.prototype.closeDrawer = function () {
        this.drawerContentRef.clear();
        this.drawerOpen = false;
        this.styleService.removeClass(this._renderer, 'html', 'no-scroll');
    };
    return DrawerComponent;
}(HasSubscriptions));
export { DrawerComponent };
